import { default as server2 } from 'server2';

export const getAssertionOptions = async (data) => {
	try {
		const {responseJSON} = await server2.my.rest
			.post(
			[
				'webauthn', 'assertionOptions',
			], {
				body: data,
			});

		return responseJSON.Data;
	} catch (error) {
		error.handled = true;
		throw error;
	}
};

export const getCredentialOptions = async (data) => {
	try {
		const {responseJSON} = await server2.my.rest
			.post(
			[
				'webauthn', 'credentialOptions',
			], {
				body: data,
			});

		return responseJSON.Data;
	} catch (error) {
		error.handled = true;
		throw error;
	}
};

export const registerWebAuthFetch = async (data) => {
	try {
		const {responseJSON} = await server2.my.rest
			.post(
			[
				'webauthn', 'credential',
			], {
				body: data,
			});

		return responseJSON.Data;
	} catch (error) {
		error.handled = true;
		throw error;
	}
};

export const loginWebAuthFetch = (data) => {
	return server2.my.cmsapi
		.post(
		[
			'lk', 'webauthn',
		], {
			body: data,
		});
};
